// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__15u55","icon":"style_icon__1xDk4"};